import { Component, ElementRef, EventEmitter, Injectable, Input, OnInit, AfterViewInit, Output, TemplateRef } from '@angular/core';
import { PaginationInstance } from 'ngx-pagination';
import { WebClientConfigurationService } from '../../services/configuration/web-client-configuration.service';
import { AuthenticationService } from '../../services/authentication.service';
import { PaginationEngine } from '../../Models/enum/paginationEngine';

@Component({
  selector: 'app-wf-table',
  templateUrl: './wf-table.component.html',
  styleUrls: ['./wf-table.component.css'],
})

@Injectable({
  providedIn: 'root',
})

export class WfTableComponent implements OnInit, AfterViewInit {

  @Input() rows?;
  @Input() columns?;
  @Input() hasPagination?: boolean;
  @Input() headFixed?: boolean;
  @Input() footerFixed?: boolean;
  @Input() additionalClasses?: string;
  @Input() paginationConfig?: PaginationInstance;
  @Input() paginationEngine?: PaginationEngine = PaginationEngine.client;

  @Input() columnsTemplate: TemplateRef<any>;
  @Input() rowsTemplate: TemplateRef<any>;

  @Output() changePage: EventEmitter<any> = new EventEmitter();

  currentColumnsTemplate: TemplateRef<any>;
  currentRowsTemplate: TemplateRef<any>;

  classHeadFixed = 'table-head-fixed';
  public lastColumnSort: string = "";
  public dataTableId: string;

  constructor(
    private webClientConfig: WebClientConfigurationService,
    private authenticationService: AuthenticationService,
    private _elementRef: ElementRef
  ) {  }


  ngOnInit() {
    this.currentColumnsTemplate = this.columnsTemplate;
    this.currentRowsTemplate = this.rowsTemplate;
  }

  ngAfterViewInit() {
    this.dataTableId =  this._elementRef.nativeElement.id;
  }

  showTable() {
    return this.hasPagination ? this.paginationConfig : true;
  }

  onPageChange(page) {
    if (this.paginationEngine === PaginationEngine.server) {
      this.changePage.emit(page);
    } else {
      this.paginationConfig.currentPage = page;
    }
  }


}

